/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kamembe 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Cyangugu": ["Gatovu", "Karambo", "Karangiro", "Mont Cyangugu", "Mundima", "Ngoma", "Ntwari"],
  "Gihundwe": ["Batero", "Burunga", "Kabeza", "Munyinya", "Murambi", "Nkurunziza"],
  "Kamashangi": ["Amahoro", "Badura", "Gitinda", "Kadasomwa", "Kannyogo", "Mbagira", "Mucyamo", "Ntemabiti", "Nyakayonga", "Rushakamba", "Umuganda"],
  "Kamurera": ["Cyapa", "Gikombe", "Kamuhirwa", "Murangi"],
  "Ruganda": ["Kadashya", "Kamubaji", "Murindi", "Ruhimbi"]
};